import { toast } from '../ui';

const STORAGE_KEY = 'hr_sheets_url';

export function initSheetsSection(): void {
  const inp = document.getElementById('sheetsUrlInp') as HTMLInputElement | null;
  if (inp) inp.value = localStorage.getItem(STORAGE_KEY) ?? '';
  updateSheetPreview();
}

export function saveSheetUrl(): void {
  const inp = document.getElementById('sheetsUrlInp') as HTMLInputElement;
  const url = inp.value.trim();
  if (!url) { toast('error', 'กรุณาใส่ URL ของ Google Sheets'); return; }
  if (!url.includes('docs.google.com/spreadsheets') && !url.includes('sheets.google.com')) {
    toast('error', 'URL ไม่ถูกต้อง กรุณาใช้ลิงก์จาก Google Sheets');
    return;
  }
  localStorage.setItem(STORAGE_KEY, url);
  toast('success', 'บันทึก URL แล้ว');
  updateSheetPreview();
}

export function openSheet(): void {
  const url = localStorage.getItem(STORAGE_KEY)
    ?? (document.getElementById('sheetsUrlInp') as HTMLInputElement | null)?.value.trim();
  if (!url) { toast('error', 'กรุณาบันทึก URL ก่อนเปิด'); return; }
  window.open(url, '_blank', 'noopener,noreferrer');
}

function updateSheetPreview(): void {
  const url   = localStorage.getItem(STORAGE_KEY) ?? '';
  const badge = document.getElementById('sheetsSavedBadge') as HTMLElement | null;
  const openBtn = document.getElementById('sheetsOpenBtn') as HTMLButtonElement | null;
  if (!badge || !openBtn) return;
  if (url) {
    badge.style.display = 'flex';
    badge.textContent = url.length > 60 ? url.slice(0, 57) + '…' : url;
    openBtn.disabled = false;
  } else {
    badge.style.display = 'none';
    openBtn.disabled = true;
  }
}
